import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Box, styled } from '@mui/material';
var StyledModalContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;

  var styles = _defineProperty({
    padding: theme.spacing(4),
    borderRadius: theme.typography.pxToRem(12)
  }, theme.breakpoints.down('md'), {
    padding: theme.spacing(3, 2)
  });

  return styles;
});
export { StyledModalContainer };